import { cn } from "@/lib/utils";

interface Abstract3DShapesProps {
  className?: string;
  density?: "sparse" | "balanced" | "dense";
}

export const Abstract3DShapes = ({ 
  className,
  density = "balanced" 
}: Abstract3DShapesProps) => {
  const shapes = density === "sparse" ? 3 : density === "balanced" ? 5 : 8;

  return (
    <div className={cn("absolute inset-0 overflow-hidden pointer-events-none", className)}>
      {/* Top Left - Teal Cube */}
      <div 
        className="absolute top-[10%] left-[5%] w-24 h-24 opacity-15 animate-float"
        style={{ animationDelay: "0s" }}
      >
        <div className="w-full h-full bg-gradient-to-br from-brand-teal to-brand-teal-600 rounded-lg shadow-2xl transform rotate-12" />
      </div>

      {/* Top Right - Purple Sphere */}
      <div 
        className="absolute top-[15%] right-[8%] w-32 h-32 opacity-20 animate-float"
        style={{ animationDelay: "1s" }}
      >
        <div className="w-full h-full bg-gradient-to-br from-brand-purple to-brand-purple-600 rounded-full shadow-2xl" />
      </div>

      {/* Middle Left - Orange Pyramid */}
      {shapes >= 5 && (
        <div 
          className="absolute top-[45%] left-[10%] w-20 h-20 opacity-15 animate-float"
          style={{ animationDelay: "2s" }}
        >
          <div 
            className="w-full h-full bg-gradient-to-br from-brand-orange to-brand-orange-600 shadow-2xl"
            style={{ clipPath: "polygon(50% 0%, 0% 100%, 100% 100%)" }}
          />
        </div>
      )}

      {/* Bottom Right - Green Hexagon */}
      {shapes >= 5 && (
        <div 
          className="absolute bottom-[20%] right-[12%] w-28 h-28 opacity-18 animate-float"
          style={{ animationDelay: "3s" }}
        >
          <div 
            className="w-full h-full bg-gradient-to-br from-brand-green to-brand-green-600 shadow-2xl"
            style={{ clipPath: "polygon(30% 0%, 70% 0%, 100% 50%, 70% 100%, 30% 100%, 0% 50%)" }}
          />
        </div>
      )}

      {/* Middle Right - Yellow Diamond */}
      {shapes >= 5 && (
        <div 
          className="absolute top-[60%] right-[5%] w-16 h-16 opacity-15 animate-float"
          style={{ animationDelay: "1.5s" }}
        >
          <div 
            className="w-full h-full bg-gradient-to-br from-brand-yellow to-brand-yellow-600 rounded shadow-2xl transform rotate-45"
          />
        </div>
      )}

      {/* Dense Mode Additional Shapes */}
      {shapes >= 8 && (
        <>
          <div 
            className="absolute top-[30%] right-[25%] w-14 h-14 opacity-12 animate-float"
            style={{ animationDelay: "2.5s" }}
          >
            <div className="w-full h-full bg-gradient-to-br from-brand-teal to-brand-purple rounded-lg shadow-xl transform -rotate-12" />
          </div>

          <div 
            className="absolute bottom-[35%] left-[20%] w-18 h-18 opacity-15 animate-float"
            style={{ animationDelay: "3.5s" }}
          >
            <div className="w-full h-full bg-gradient-to-br from-brand-orange to-brand-red rounded-full shadow-xl" />
          </div>

          <div 
            className="absolute top-[75%] left-[15%] w-12 h-12 opacity-12 animate-float"
            style={{ animationDelay: "4s" }}
          >
            <div 
              className="w-full h-full bg-gradient-to-br from-brand-purple to-brand-teal shadow-xl"
              style={{ clipPath: "polygon(50% 0%, 0% 100%, 100% 100%)" }}
            />
          </div>
        </>
      )}
    </div>
  );
};
